import type { SVGProps } from 'react';

const SvgSearchBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M19.2929 20.7071C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929L20 20L19.2929 20.7071ZM17 10.5H16C16 13.5376 13.5376 16 10.5 16V17V18C14.6421 18 18 14.6421 18 10.5H17ZM10.5 17V16C7.46243 16 5 13.5376 5 10.5H4H3C3 14.6421 6.35786 18 10.5 18V17ZM4 10.5H5C5 7.46243 7.46243 5 10.5 5V4V3C6.35786 3 3 6.35786 3 10.5H4ZM10.5 4V5C13.5376 5 16 7.46243 16 10.5H17H18C18 6.35786 14.6421 3 10.5 3V4ZM15 15L14.2929 15.7071L19.2929 20.7071L20 20L20.7071 19.2929L15.7071 14.2929L15 15Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgSearchBd;
